import axios from "axios";
import config from "../config";

const axiosClient = axios.create({
  baseURL: config.backendUrl || "",
});

export default axiosClient;
